<div class="summary-card" [ngClass]="{ 'is-missing': !bond && !bondRequest }">
  <div class="summary-card-logo">
    <div class="card-logo">
      <img *ngIf="info.imgSrc" src="assets/icons/{{ info.imgSrc }}.svg" [alt]="info.title | translate" />
    </div>
  </div>
  <div class="summary-card-content">
    <div class="summary-card-header">
      <div>
        <h5>
          {{ info.title | translate }}
        </h5>
      </div>
      <div class="summary-card-edit" *ngIf="canEdit">
        <button class="btn btn-link" (click)="gotoEdit()"><i class="fa fa-pencil"></i></button>
      </div>
    </div>
    <div class="container-card-body">
      <ng-container *ngIf="!bond && !bondRequest">
        <div class="row">
          <div class="col-12">{{ info.isMissing | translate }}</div>
        </div>
      </ng-container>
      <ng-container *ngIf="!!bond">
        <div class="row">
          <div class="col-6 card-label">{{ "LABELS.BOND_TYPE" | translate }}</div>
          <div class="col-6" *ngIf="isContinuous">{{ "BOND_TYPE.CONTINUOUS" | translate }}</div>
          <div class="col-6" *ngIf="!isContinuous">{{ "BOND_TYPE.SINGLE_TRANSACTION" | translate }}</div>
        </div>

        <div class="row" *ngIf="bond.suretyCode">
          <div class="col-6 card-label">{{ "FORM_LABEL.SURETYCODE" | translate }}</div>
          <div class="col-6">
            {{ bond.suretyCode }}
            <div class="text-error" *ngIf="getValidationText('suretyCode')">
              {{ getValidationText("suretyCode") | translate }}
            </div>
          </div>
        </div>
        <div class="row" *ngIf="bond.referenceNumber">
          <div class="col-6 card-label">{{ "LABELS.REFERENCE_NUMBER" | translate }}</div>
          <div class="col-6">
            {{ bond.referenceNumber }}
            <div class="text-error" *ngIf="getValidationText('referenceNumber')">
              {{ getValidationText("referenceNumber") | translate }}
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!!bondRequest">
        <div class="row">
          <div class="col-12">
            {{
              (bondRequest.bondType === enumBondType.SINGLE_TRANSACTION ? singleBondText : info.purchaseContinuousBondRequested) | translate
            }}
          </div>
        </div>

        <div class="row" *ngIf="isShowBR">
          <div class="col-6 card-label">{{ "LABELS.BOND_REQUEST_NUMBER" | translate }}</div>
          <div class="col-6">
            <a href="" [routerLink]="['/bond-requests-management', bondRequest?.id]">{{ bondRequest?.referenceNumber }}</a>
          </div>
        </div>

        <div *ngIf="bondRequest.bondType === enumBondType.SINGLE_TRANSACTION" class="row">
          <div class="col-6 card-label">{{ "LABELS.ARRIVAL_PORT" | translate }}</div>
          <div class="col-6">
            {{ arrivalPort ? arrivalPort.code + " " + arrivalPort.description : bondRequest.portCode }}
            <div class="text-error" *ngIf="bondRequestPortCodeValidationText">
              {{ bondRequestPortCodeValidationText | translate }}
            </div>
          </div>
        </div>
        <div *ngIf="bondRequest.bondType === enumBondType.SINGLE_TRANSACTION && importer" class="row">
          <div class="col-6 card-label">{{ "FORM_LABEL.IMPORTER_IDENTIFIER" | translate }}</div>
          <div class="col-6">
            {{ (importerIdentifierQual | translate) + " " + importerIdentifier }}
          </div>
        </div>
        <div *ngIf="bondRequest.bondType === enumBondType.CONTINUOUS" class="row">
          <div class="col-6 card-label">{{ "FORM_LABEL.IMPORTER_IDENTIFIER" | translate }}</div>
          <div class="col-6">
            {{ bondRequest.continuousBondDetails.importerNumber }}
          </div>
        </div>
        <div *ngIf="bondRequest.bondType === enumBondType.SINGLE_TRANSACTION && importer" class="row">
          <div class="col-6 card-label">{{ "FORM_LABEL.IMPORTER_NAME" | translate }}</div>
          <div class="col-6">{{ importer.name }}</div>
        </div>
        <div *ngIf="bondRequest.bondType === enumBondType.CONTINUOUS" class="row">
          <div class="col-6 card-label">{{ "FORM_LABEL.IMPORTER_NAME" | translate }}</div>
          <div class="col-6">{{ bondRequest.continuousBondDetails.companyName }}</div>
        </div>
        <div *ngIf="bondRequest.bondType === enumBondType.CONTINUOUS" class="row">
          <div class="col-6 card-label">{{ "FORM_LABEL.STATE" | translate }}</div>
          <div class="col-6">
            <div>
              {{ "BOND_REQUEST_STATE." + enumBondRequestState[bondRequest.state] | translate }}
            </div>
            <div class="text-error" *ngIf="bondRequestNotSentError">{{ bondRequestNotSentError | translate }}</div>
          </div>
        </div>
        <div *ngIf="bondRequest.bondType === enumBondType.CONTINUOUS" class="row">
          <div class="col-6 card-label">{{ "LABELS.PAYMENT_STATE" | translate }}</div>
          <div class="col-6">
            <bill-status [billStatus]="bondRequest.paymentState"></bill-status>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
